module.exports = __webpack_public_path__ + "static/media/img_simulation_assessment_info_noselip_width.adaefe58.jpg";